

































































































































































































































import { ICitationSearchResult } from './ICitationSearchResult';
import constants from '@/constants';
import fileSaver from 'file-saver';
import { mapGetters } from 'vuex';
import VatsAPI from '@/Shared/VatsAPI';
import LocationBasedMixin from '@/Shared/LocationBasedMixin';
import mixins from 'vue-typed-mixins';
import { formatDate } from '@/Shared/Filters';

export default mixins(LocationBasedMixin).extend({
    data() {
        return {
        };
    },
    computed: {
        ...mapGetters('citationModule', [
            'searchResults',
            'searchError',
            'searchInProgress',
            'searchParams'
        ])
    },
    methods: {
        async download() {
            this.$typedStore.modules.citationModule.mutations.setSearchBegun(null);
            try {
                const response = (await VatsAPI.post<Blob>(`${this.location}/citations/search`,
                    this.searchParams, {
                    headers: {
                        accept: constants.ExcelMimeType
                    },
                    responseType: 'blob'
                }));

                fileSaver.saveAs(response.data, `${this.$t('citation.search.results.resultsExcelFileName')}.xlsx`);
            }
            finally {
                this.$typedStore.modules.citationModule.mutations.setSearchEnd(null);
            }
        },
        formatDate(date: Date): string {
            return encodeURI(formatDate(date));
        },
        getCitationStatusClasses(citation: ICitationSearchResult): string {
            let statusClass: string = '';
            if (citation.scofflawEligible) {
                statusClass = 'scofflaw';
            }
            else if (citation.writtenOff) {
                statusClass = 'write-off';
            }
            else if (citation.collectionsDateTransferred) {
                statusClass = 'sent-to-collections';
            }
            else if (citation.onHold) {
                statusClass = 'on-hold';
            }
            else if (citation.underAppeal) {
                statusClass = 'under-appeal';
            }
            else if (citation.sentToCourtDate) {
                statusClass = 'sent-to-court';
            }
            else if (citation.hearingScheduled) {
                statusClass = 'hearing-scheduled';
            }
            return statusClass;
        },
    },
});

